import { axiosInstance } from '@/api/axiosInstance';
import { IUnitModel } from './unitModels';

export default async function apiUnitCreate(unit: IUnitModel): Promise<boolean> {
    return await axiosInstance.post('/v1/units/', unit);
}